<template>
  <div class="text-justify basic">
    <div v-html="block.form.text"></div>
  </div>
</template>

<script>
export default {
  props: {
    block: {}
  }
};
</script>

<style lang="scss" scoped></style>
